<template>
  <div class="VotingForm">
    <div class="votoDocen" v-if="votoDocen">
      <div class="titutleDoc"><h3>Candidatos Docentes</h3></div>
      <div class="container">
        <div class="row">
          <div v-for="item of this.InfoRange.VotingTeachers" :key="item.id" class="col-12 col-md-12 col-sm-12 col-lg-4">
            <div v-if="item.Id_Person === 0" class="searchVoto row card text-center" :id="item.Id_VotingUsers">
              <div class="card-header col-md-12">Voto en Blanco</div>
              <div class="card-body searchVotoSelect"><img width="150" height="150" src="@/assets/images/votoBlanco.png" id="item.Id_VotingUsers"/></div>
              <div class="card-footer">
                <div class="row text-center">
                  <div class="col-md-12"><img src="@/assets/images/VotoPropuesta2.png" class="img-fluid imgProp"  v-on:click="viewPropuesta('bv-modal-'+item.Id_VotingUsers)"/></div>
                  <div class="col-md-12">¡Vota aquí!</div>
                  <div class="col-md-3"></div>
                  <div class="col-md-9">
                    <div class="form col-md-12">
                      <input type="checkbox" class="checkVal" :id="'check_'+item.Id_VotingUsers" v-on:click="executeVotoAlumno" />
                      <label :for="'check_'+item.Id_VotingUsers" style="--d: 60%;"><svg viewBox="0,0,50,50"><path d="M5 30 L 20 45 L 45 5" /></svg></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="searchVoto row card text-center" :id="item.Id_VotingUsers">
              <div class="card-header col-md-12"><b>{{item.Nam_Person}} {{item.Last_NamePerson}}</b></div>
              <div class="card-body searchVotoSelect">
                <img width="150" height="150" :src="item.Det_Photo" :id="item.Id_VotingUsers" />
                <modal :name="'bv-modal-'+item.Id_VotingUsers" width="50%" height="auto" :scrollable="true" :adaptive="true" :clickToClose="true" style="overflow:scroll">
                    <template v-slot:modal-title>Propuesta {{item.Nam_Person}} {{item.Last_NamePerson}}</template>
                    <div class="detallePro"><div v-html="item.Det_Proposal"></div></div>
                </modal>
              </div>
              <div class="card-footer">
                <div class="row text-center">
                  <div class="col-md-12"><img src="@/assets/images/VotoPropuesta2.png" class="img-fluid imgProp"  v-on:click="viewPropuesta('bv-modal-'+item.Id_VotingUsers)"/></div>
                  <div class="col-md-12">¡Vota aquí!</div>
                  <div class="col-md-3"></div>
                  <div class="col-md-9">
                    <div class="form col-md-12">
                      <input type="checkbox" class="checkVal" :id="'check_'+item.Id_VotingUsers" v-on:click="executeVotoAlumno" />
                      <label :for="'check_'+item.Id_VotingUsers" style="--d: 60%;"><svg viewBox="0,0,50,50"><path d="M5 30 L 20 45 L 45 5" /></svg></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="votoEstudi" v-if="votoEstudi">
      <div class="titutleEst"><h3>Candidatos Estudiantes</h3></div>
      <div class="container">
        <div class="row">
          <div v-for="item of this.InfoRange.VotingStudents" :key="item.id" class="col-12 col-md-12 col-sm-12 col-lg-4">
            <div v-if="item.Id_Person === 0" class="searchVoto row card text-center" :id="item.Id_VotingUsers">
              <div class="card-header col-md-12">Voto en Blanco</div>
              <div class="card-body searchVotoSelect"><img width="150" height="150" src="@/assets/images/votoBlanco.png" id="item.Id_VotingUsers" /></div>
              <div class="card-footer">
                <div class="row text-center">
                  <div class="col-md-12"><img src="@/assets/images/VotoPropuesta2.png" class="img-fluid imgProp"  v-on:click="viewPropuesta('bv-modal-'+item.Id_VotingUsers)"/></div>
                  <div class="col-md-12">¡Vota aquí!</div>
                  <div class="col-md-3"></div>
                  <div class="col-md-9">
                    <div class="form col-md-12">
                      <input type="checkbox" class="checkVal" :id="'check_'+item.Id_VotingUsers" v-on:click="executeVotoAlumno" />
                      <label :for="'check_'+item.Id_VotingUsers" style="--d: 60%;"><svg viewBox="0,0,50,50"><path d="M5 30 L 20 45 L 45 5" /></svg></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="searchVoto row card text-center" :id="item.Id_VotingUsers">
              <div class="card-header col-md-12"><b>{{item.Nam_Person}} {{item.Last_NamePerson}}</b></div>
              <div class="card-body searchVotoSelect">
                <img width="150" height="150" :src="item.Det_Photo" :id="item.Id_VotingUsers" />
                <modal :name="'bv-modal-'+item.Id_VotingUsers" width="50%" height="auto" :scrollable="true" :adaptive="true" :clickToClose="true" style="overflow:scroll">
                    <template v-slot:modal-title>Propuesta {{item.Nam_Person}} {{item.Last_NamePerson}}</template>
                    <div class="detallePro"><div v-html="item.Det_Proposal"></div></div>
                </modal>
              </div>
              <div class="card-footer">
                <div class="row text-center">
                  <div class="col-md-12"><img src="@/assets/images/VotoPropuesta2.png" class="img-fluid imgProp"  v-on:click="viewPropuesta('bv-modal-'+item.Id_VotingUsers)"/></div>
                  <div class="col-md-12">¡Vota aquí!</div>
                  <div class="col-md-3"></div>
                  <div class="col-md-9">
                    <div class="form col-md-12">
                      <input type="checkbox" class="checkVal" :id="'check_'+item.Id_VotingUsers" v-on:click="executeVotoAlumno" />
                      <label :for="'check_'+item.Id_VotingUsers" style="--d: 60%;"><svg viewBox="0,0,50,50"><path d="M5 30 L 20 45 L 45 5" /></svg></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="text-left  col-md-10">
            <va-notification color="danger" v-if="NoVoto" class="refNoData">Por favor debe seleccionar un candidato para registrar su voto.</va-notification>
        </div>
        <div class="text-center  col-md-10">
            <button type="submit" v-on:click="executeProcess" class="loginbtn primaryBtn">Votar</button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VotingForm',
  data () {
    return {
      voto: {
        student: '',
        teacher: '',
        refVoto: this.InfoRange.Id_VotingRange,
      },
      votoDocen: true,
      votoEstudi: false,
      NoVoto: false,
    }
  },
  methods: {
    executeProcess () {
      debugger
      /* if ((this.votoDocen) && this.voto.teacher === '') {
        this.NoVoto = true
      } */
      if (/* this.votoEstudi === true && */ this.voto.student === '') {
        this.NoVoto = true
      }
      if (!this.NoVoto) {
        this.method(this.voto)
      }
    },
    viewPropuesta (idref) {
      this.$modal.show(idref)
    },
    clearCheckboxes (idNot) {
      var checkboxes = document.getElementsByTagName('input')
      for (var i = 0; i < checkboxes.length; i++) {
        if ((checkboxes[i].type === 'checkbox') && (idNot !== checkboxes[i].id)) {
          checkboxes[i].checked = false
        }
      }
    },
    executeVotoDocent (event) {
      this.clearCheckboxes(event.target.id)
      this.NoVoto = false
      if (event.target.checked) {
        this.voto.teacher = event.target.id.substr(6)
      } else {
        this.voto.teacher = ''
      }
    },
    executeVotoAlumno (event) {
      this.clearCheckboxes(event.target.id)
      this.NoVoto = false
      if (event.target.checked) {
        this.voto.student = event.target.id.substr(6)
      } else {
        this.voto.student = ''
      }
    },
  },
  created: function () {
    debugger
    var infdata = this.$session.get('IberoJWTAdminLogin')
    var idRol = infdata.idUserType[0].Id_Role
    if (idRol === 15) {
      this.votoDocen = false
      this.votoEstudi = true
    }
  },
  props: {
    method: Function,
    InfoRange: Object,
  },
}
</script>

<style scoped>

.selectVoto {
  background-color: #a2273c !important;
}

.VotingForm {
    background-color: #ffffff;
}

@media (min-width: 600px) {
  .VotingForm {
      margin: 10px;
      padding: 10px;
  }
}

input.checkVal {
  position: absolute;
  opacity: 0;
}
input.checkVal:checked + label svg path {
  stroke-dashoffset: 0;
}
input.checkVal:focus + label {
  transform: scale(1.03);
}

.checkVal + label {
  display: block;
  border: 5px solid #979797;
  width: var(--d);
  height: var(--d);
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.checkVal + label:active {
  transform: scale(1.05);
  border-radius: 10px;
}
.checkVal + label svg {
  pointer-events: none;
}
.checkVal + label svg path {
  fill: none;
  stroke: #a2273c;
  stroke-width: 4px;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 100;
  stroke-dashoffset: 101;
  transition: all 350ms cubic-bezier(1, 0, 0.37, 0.91);
  cursor: pointer;
}

.dtlvoto {
  font-size: 25px;
  font-weight: bold;
  padding: 10px;
}

.titutleDoc,
.titutleEst {
  display: none;
}

.searchVoto {
  margin: 20px !important;
   box-shadow: 6px 6px 6px #cabec0;
   min-width: 220px !important;
}

.imgProp {
  width: 50%;
  cursor: pointer;
}

.card-header {
  text-transform: uppercase;
  min-height: 70px;
  max-height: 70px;
}

.imgPropVB{
    opacity: 0.5;
    cursor:unset;
}

.refNoData {
   margin-top: 25px;
  padding: 10px;
  padding-left: 20px;
}

.form{
  padding-top: 5px;
}

.detallePro{
  padding: 20px;
  overflow: scroll;
  text-align: justify;
}
</style>